<template>
    <div class="detail-rank">
        <div class="rank-left" @click="toRankList(0)">
            <img
                :src="rankIcon" alt=""
                class="rank-left-icon"
            >
            <span class="rank-left-tab-name">{{ leftTabName }}
                {{ leftRankNum > 0 ? `No.${leftRankNum}` : '' }}</span>
        </div>
        <div class="rank-separator"></div>
        <div class="ranl-right" @click="toRankList(1)">
            <img
                :src="rankIcon" alt=""
                class="rank-right-icon"
            >
            <span class="rank-right-tab-name">{{ rightTabName }}
                {{ rightRankNum > 0 ? `No.${rightRankNum}` : '' }}</span>
        </div>
    </div>
</template>

<script>
import {getQueryString} from '@/utils/url';
import rank_icon from 'public/assets/imgs/zone-detail-rank-icon.png';
export default {
    props: {
        rankList: {
            type: Array,
            default: () => [],
        },
        info: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            rankIcon: rank_icon,
            leftTabName: '',
            rightTabName: '',
            leftRankNum: '',
            rightRankNum: '',
        };
    },
    watch: {
        rankList: {
            handler() {
                this.leftTabName = decodeURI(this.rankList[0].rank_name);
                this.rightTabName = decodeURI(this.rankList[1].rank_name);
                this.leftRankNum = this.rankList[0].rank_num;
                this.rightRankNum = this.rankList[1].rank_num;
            },
        },
    },
    methods: {
        toRankList(index) {
            this.$emit('toRank', index);
            this.$logger.click({
                type: 'click',
                value: 'clickRankTab',
                ext: {
                    ext: {
                        loc: index === 1 ? 'right' : 'left',
                        gameName: this.info.appName,
                        gameId: this.info.appId,
                        tabName: index === 0 ? this.leftTabName : this.rightTabName,
                        sid: getQueryString('sid') || '',
                        srcId: getQueryString('srcid') || '',
                        channelid: getQueryString('channelid') || '',
                    },
                    pos: '',
                },
            });
        },
    },
};
</script>

<style lang="scss">
.detail-rank {
    width: 1140px;
    height: 114px;
    background: #F8F8F8;
    border-radius: 27px;
    display: flex;
    align-items: center;
    margin: 45px 0 20px 0;
    box-sizing: border-box;
    position: relative;
    justify-content: space-around;
    .rank-separator {
        width: 2px;
        height: 48px;
        background: #D8D8D8;
        position: absolute;
        top: 33px;
        left: 569px;
    }
    .rank-left {
        display: flex;
        align-items: center;
        margin-left: 69px;
       .rank-left-icon {
           width: 45px;
           height: 45px;
           margin-right: 26px;
       }
       .rank-left-tab-name {
           width: 370px;
           white-space: nowrap;
           text-overflow:ellipsis;
           overflow: hidden;
       }
    }
    .ranl-right {
        display: flex;
        align-items: center;
        .rank-right-tab-name {
            width: 370px;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow: hidden;
        }
        .rank-right-icon {
           width: 45px;
           height: 45px;
           margin-right: 26px;
       }
    }
}
</style>